import { render, staticRenderFns } from "./BulkTrack.vue?vue&type=template&id=460bfa7b&scoped=true&"
import script from "./BulkTrack.vue?vue&type=script&lang=js&"
export * from "./BulkTrack.vue?vue&type=script&lang=js&"
import style0 from "./BulkTrack.vue?vue&type=style&index=0&id=460bfa7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460bfa7b",
  null
  
)

export default component.exports